import { SearchPageMetadata } from "./search-metadata.types";

/**
 * Mock of the GET /api/v1/search/metadata payload.
 * Pure data — the same JSON the backend is expected to serve.
 * Field sets, masks, and result columns follow the LegacyLink Search Figma.
 */
export const SEARCH_PAGE_METADATA: SearchPageMetadata = {
  defaultTab: "patient",
  tabs: [
    {
      key: "patient",
      tabLabel: "Patient",
      title: "Search by Patient",
      fields: [
        {
          name: "lastName",
          label: "Last Name",
          isDefault: true,
          validation: {
            maxLength: 25,
            maxLengthMessage: "Last name must be 25 characters or less",
          },
        },
        {
          name: "firstName",
          label: "First Name",
          isDefault: true,
          validation: {
            maxLength: 25,
            maxLengthMessage: "First name must be 25 characters or less",
          },
        },
        {
          name: "dateOfBirth",
          label: "Date of Birth",
          isDefault: true,
          mask: "99/99/9999",
          slotChar: "mm/dd/yyyy",
          placeholder: "mm/dd/yyyy",
          validation: { rule: "dateOfBirth" },
        },
        {
          name: "mrn",
          label: "MRN",
          isDefault: false,
          validation: {
            pattern: "^\\d+$",
            patternMessage: "MRN must contain only digits",
          },
        },
        {
          name: "ssn",
          label: "SSN",
          isDefault: false,
          mask: "999-99-9999",
          placeholder: "xxx-xx-xxxx",
          validation: {
            pattern: "^\\d{3}-\\d{2}-\\d{4}$",
            patternMessage: "SSN must be 9 digits",
          },
        },
        {
          name: "phone",
          label: "Phone",
          isDefault: false,
          mask: "999-999-9999",
          placeholder: "xxx-xxx-xxxx",
          validation: {
            pattern: "^\\d{3}-\\d{3}-\\d{4}$",
            patternMessage: "Phone must be 10 digits",
          },
        },
        {
          name: "address",
          label: "Address",
          isDefault: false,
        },
      ],
      results: {
        rowAction: "openPatient",
        columns: [
          { field: "lastName", header: "Last Name" },
          { field: "firstName", header: "First Name" },
          { field: "middleName", header: "Middle Name", rendererId: "dash" },
          { field: "dateOfBirth", header: "Date of Birth", rendererId: "date" },
          {
            field: "medicalRecordNumber",
            header: "Medical Record Number",
            rendererId: "dash",
          },
          {
            field: "accountNumber",
            header: "Account Number",
            rendererId: "dash",
          },
          { field: "facility", header: "Facility" },
          { field: "application", header: "Application" },
        ],
      },
    },
    {
      key: "employee",
      tabLabel: "Employee",
      title: "Search by Employee",
      fields: [
        {
          name: "lastName",
          label: "Last Name",
          isDefault: true,
          validation: {
            maxLength: 25,
            maxLengthMessage: "Last name must be 25 characters or less",
          },
        },
        {
          name: "firstName",
          label: "First Name",
          isDefault: true,
          validation: {
            maxLength: 25,
            maxLengthMessage: "First name must be 25 characters or less",
          },
        },
        {
          name: "employeeId",
          label: "Employee ID",
          isDefault: true,
        },
      ],
      results: {
        columns: [
          { field: "lastName", header: "Last Name" },
          { field: "firstName", header: "First Name" },
          { field: "middleName", header: "Middle Name", rendererId: "dash" },
          { field: "employeeId", header: "Employee ID" },
          { field: "facility", header: "Facility" },
          { field: "application", header: "Application" },
        ],
      },
    },
    {
      key: "vendor",
      tabLabel: "Vendor",
      title: "Search by Vendor",
      fields: [
        { name: "vendorName", label: "Vendor Name", isDefault: true },
        { name: "vendorId", label: "Vendor ID", isDefault: true },
      ],
      results: {
        columns: [
          { field: "setId", header: "Set ID" },
          { field: "vendorId", header: "Vendor ID" },
          { field: "persistence", header: "Persistence" },
          { field: "shortVendorName", header: "Short Vendor Name" },
          { field: "ourCustomerNumber", header: "Our Customer Number" },
          { field: "name", header: "Name" },
        ],
      },
    },
    {
      key: "purchaseOrder",
      tabLabel: "Purchase Order",
      title: "Search by Purchase Order",
      fields: [
        {
          name: "purchaseOrderId",
          label: "Purchase Order ID",
          isDefault: true,
        },
      ],
      results: {
        columns: [
          { field: "businessUnit", header: "Business Unit" },
          { field: "poId", header: "PO ID" },
          { field: "poDate", header: "PO Date", rendererId: "date" },
          { field: "poStatus", header: "PO Status" },
          { field: "supplierId", header: "Supplier ID" },
          { field: "supplierName", header: "Supplier Name" },
          { field: "buyerId", header: "Buyer ID" },
          { field: "buyerName", header: "Buyer Name" },
          { field: "poType", header: "PO Type" },
          { field: "poReference", header: "PO Reference" },
        ],
      },
    },
  ],
};
